export default "__VITE_ASSET__B6Avs_gW__"